import { createContext, useContext, useEffect, useState } from "react";

const LangCtx = createContext({ lang: "en", setLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("ns_lang") || "en");
  useEffect(() => {
    localStorage.setItem("ns_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return (
    <LangCtx.Provider value={{ lang, setLang: setLangState }}>{children}</LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx);
